import React from 'react';
import PropTypes from 'prop-types';
import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = ({ items }) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <div className={styles['Breadcrumbs']}>
            <div className={styles['Breadcrumbs__Container']}>
                <nav
                    className={styles['Breadcrumbs__ListWrap']}
                    aria-label="breadcrumb">
                    <ul className={styles['Breadcrumbs__List']}>
                        {items.map((item, idx) => {
                            return (
                                <li
                                    key={idx}
                                    className={styles['Breadcrumbs__Item']}>
                                    {idx < items.length - 1 ? (
                                        <a
                                            href={item.href}
                                            className={
                                                styles['Breadcrumbs__Link']
                                            }>
                                            {item.breadcrumbTitle}
                                        </a>
                                    ) : (
                                        <span
                                            className={
                                                styles['Breadcrumbs__Last']
                                            }>
                                            {item.breadcrumbTitle}
                                        </span>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </div>
    );
};

Breadcrumbs.propTypes = {
    items: PropTypes.array,
};

Breadcrumbs.defaultProps = {
    items: [],
};

export default Breadcrumbs;
